import { useEffect, useRef } from 'react'
import { usePostHog } from 'posthog-js/react'

interface Metadata {
  entityId?: string
  entityName?: string
}
export const usePostHogEntityViewed = (eventName: string, metadata?: Metadata) => {
  const posthog = usePostHog()
  const lastSentIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (import.meta.env.MODE !== 'production' || !posthog) {
      return
    }
    const viewedId = `${eventName}:${metadata?.entityId || ''}:${metadata?.entityName || ''}`

    if (lastSentIdRef.current === viewedId) {
      return
    }

    posthog.capture(eventName, {
      entity_id: metadata?.entityId,
      entity_name: metadata?.entityName,
    })

    lastSentIdRef.current = viewedId
  }, [posthog, metadata?.entityId, metadata?.entityName, eventName])
}
